export default __webpack_public_path__ + "static/media/borough.f5dc5989.png";